export abstract class AuthStrategy {
  abstract signOut(): Promise<void>;
}
